'use client';

import { useClientLocale, useClientTranslation } from '@bts-web/utils-lokalise';
import { TFunction } from 'i18next';
import { getTransactionDetailsTranslations } from '../utils/getTransactionDetailsTranslations';
import { useTransactionDetails } from '../hooks/useTransactionDetails.use-client';
import { TransactionDetailsLayout } from '../TransactionDetailsLayout/TransactionDetailsLayout';
import { TransactionDetailsSkeleton } from '../TransactionDetailsSkeleton/TransactionDetailsSkeleton';
import { TransactionDetails } from '../TransactionDetails/TransactionDetails';
import { Drawer } from '../../common/components/Drawer/Drawer';
import {
  transactionTypeByTypeName,
  TransactionTypes,
} from '../../transactions/types/transactions';
import { GenericErrorMessage } from '../../layouts/GenericErrorMessage/GenericErrorMessage';

export const transactionDetailsDrawerId = 'transaction_details_drawer';

export const TransactionDetailsDrawer = ({
  tradeId,
  transactionType,
}: {
  tradeId: string;
  transactionType: TransactionTypes;
}) => {
  const locale = useClientLocale();

  const { t } = useClientTranslation();

  const isSavingsPlanTransaction =
    transactionType === transactionTypeByTypeName.SavingsPlanTransaction ||
    transactionType ===
      transactionTypeByTypeName.InternalSavingsPlanTransaction;

  const { transaction, isTransactionFetching } = useTransactionDetails({
    tradeId,
    transactionType,
  });

  const translations = getTransactionDetailsTranslations(t as TFunction);

  const getContent = () => {
    if (isTransactionFetching) {
      return <TransactionDetailsSkeleton />;
    }

    if (!isTransactionFetching && transaction === null) {
      return <GenericErrorMessage />;
    }

    return (
      <TransactionDetails
        showActionButton={!isSavingsPlanTransaction}
        transaction={transaction as NonNullable<typeof transaction>}
        locale={locale}
        translations={translations}
        translationUtil={t as TFunction}
      />
    );
  };

  return (
    <Drawer title={translations.topBar}>
      <TransactionDetailsLayout>{getContent()}</TransactionDetailsLayout>
    </Drawer>
  );
};
